(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var extend = require('lodash.assign')

module.exports = setupSearch

function setupSearch (filter) {

  filter = filter || {}

  return function search (query, callback) {
    if (!query.length) return callback()

    var searchUrl = window.config.apiUrl + this.$input.data('search-url')
      , cacheKey = this.$input.closest('form').attr('name') + ':' + this.$input.attr('name')
      , queryFilter = extend({}, filter, this.$input.data('filter'))

    Backbone.ajax(
      { url: searchUrl
      , type: 'GET'
      , data: { filter: JSON.stringify(queryFilter), keywords: query }
      , dataType: 'json'
      , error: callback.bind(null, null)
      , success: function (data) {
          processResults(data.results)
          saveSearchResults(data.results)
          callback(data.results)
        }
      })

    function processResults (results) {
      results.forEach(function (result) {
        if (typeof result.name === 'undefined') {
          result.name = result.firstName + ' ' + result.lastName
        }
      })
    }

    function saveSearchResults (results) {
      var data = {}
      results.forEach(function (result) {
        data[result._id] = result.name
      })
      window.localStorage.setItem(cacheKey, JSON.stringify(data))
    }
  }

}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/lib/selectize-ajax-search.js","/admin/source/js/app/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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